import { Provider } from 'react-redux';
import GlobalLoading from './components/GlobalLoading/GlobalLoading';
import Store from './stores/index';
import Toaster from './components/Toaster';
import AppRouter from './routes/AppRouter';
import { injectStore } from './services/ApiServiceCall';

injectStore(Store);

function App() {
  return (
    <Provider store={Store}>
      <Toaster />
      <GlobalLoading />
      <AppRouter />
    </Provider>
  );
}

export default App;
